'use strict';

import { newModalFromString } from '../components/modal';
import FormHelpers, { addInputClearIcon } from '../util/form';

/**
 * Checks if the email value entered is correct format
 * @param {string} email - email string to check if valid
 * @returns {boolean} Whether email is valid
 */
function validateEmail (email) {
    var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    return regex.test(email);
}

class NotifyHelper {
    notifyMeModal () {
        $('body').on('click', '.js-intProductDetail-size-item', (e) => {
            if (!$(e.currentTarget).find('.notifyMe').length) {
                return;
            }
            e.preventDefault();
            let actualDiv = $(e.currentTarget).find('.notifyMe');
            this.notifyMeAction(actualDiv);
        });

        $('body').on('click', '.notifyMe', (e) => {
            e.preventDefault();
            this.notifyMeAction(e.currentTarget);
        });
    }

    notifyMeAction (notifyMeDiv) {
        var paramUrl = $(notifyMeDiv).siblings().attr('data-variation-url');
        if (!paramUrl) {
            paramUrl = $(notifyMeDiv).siblings().attr('data-url');
        }
        if ($('.js-notifyMeModal').length > 0 || $(notifyMeDiv).hasClass('js-size-personalizable')) {
            return;
        }
        if ($(notifyMeDiv).hasClass('notifyPopup')) {
            $('.js-prod-select-size-modal').remove();
            paramUrl = $(notifyMeDiv).attr('data-url');
        }
        $('.js-notifyMeModal-titleNotComingSoon').removeClass('hidden');
        $('.js-notifyMeModal-subTitleNotComingSoon').removeClass('hidden');
        $('.js-notifyMeModal-titleComingSoon').addClass('hidden');
        $('.js-notifyMeModal-subTitleComingSoon').addClass('hidden');
        let isComingSoon = $(notifyMeDiv).siblings().attr('data-iscomingsoon') == 'true';
        if (isComingSoon) {
            $('.js-notifyMeModal-titleNotComingSoon').addClass('hidden');
            $('.js-notifyMeModal-subTitleNotComingSoon').addClass('hidden');
            $('.js-notifyMeModal-titleComingSoon').removeClass('hidden');
            $('.js-notifyMeModal-subTitleComingSoon').removeClass('hidden');
        }
        $('.js-notifyMeModal-toHide').removeClass('hidden');
        $('.js-notifyMeModal-toShow').addClass('hidden');
        $('.js-notifyMeModal-notifyBtn').parent().removeClass('hidden');
        $('.continueShopping').addClass('hidden');
        $('.js-notifyMeModal-emailError').addClass('hidden');
        $('.js-notifyMeModal-duplicateError').addClass('hidden');
        const htmlContent = $($(this).data('target')).html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false, [
            'cc-notifyMeModal',
            'js-notifyMeModal',
        ]);
        if ($('.page').data('action') !== 'Product-Show') {
            $(modal.modalBox).addClass(
                'cc-hide-findInStoreButton'
            );
        }
        $(modal.modalBox).addClass(
            'rightModalAttribute cc-notifyMeModal-modalBox rightModalAttribute_sizeMedium'
        );
        let size = $(notifyMeDiv).innerText;
        $('.sizeNotify').html(size);

        let quickAddFlow = $(notifyMeDiv).hasClass('notifyMeQuickAdd');
        // Retrieve images from correct SKU (e.g: big cup models)
        var url = $('#notifyMeModalImageUrl').val();
        var pid;
        var selectedColor;
        var selectedSize;

        if (quickAddFlow) {
            pid = $(notifyMeDiv).data('pid');
            selectedColor = $(notifyMeDiv).data('color').split(' - ')[1]
                ? $(notifyMeDiv).data('color').split(' - ')[1].trim()
                : '';
            selectedSize = $(notifyMeDiv).data('value');
        } else {
            pid = decodeURIComponent($('.product-detail').attr('data-variant-pid'));
            selectedColor = $('[data-attr="color"] .swatch-value.selected').data('attr-value');
            selectedSize =
                $(notifyMeDiv).closest('label').find('input').data('size-id') + '';
            selectedSize = selectedSize.replaceAll('/', '\\/');
            $('[data-attr="size"] #' + selectedSize).prop('checked', true);
        }

        $.ajax({
            url: url,
            type: 'GET',
            data: {
                pid: pid,
                color: selectedColor,
                size: selectedSize,
            },
        }).then(function (rsp) {
            modal.setContent(rsp.renderedTemplate);

            if ($('.quickview-modal').hasClass('tingle-modal--visible') && !$('.quickview-modal').hasClass('js-notifyMe-modal')) {
                $('.quickview-modal').remove();
            }

            modal.open();
            if ($('.js-complete-your-promo-quick-view').length > 0) {
                $(modal.modalBox).find('#findInStore-modal').addClass('hide');
            }
            // Enable addInputClearIcon inside class FormHelpers
            FormHelpers.init($('.js-notifyMeModal'));
            // Call addInputClearIcon for the current or every future input in this modal.
            $('input[type=text],input[type=email]').each(function (index, inputItem) {
                addInputClearIcon(inputItem);
            });
        });

        $(modal.modalBox).on('click', '.js-notifyMeModal-close', (e) => {
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.continue-shopping-link', (e) => {
            e.preventDefault();
            let sku = $('div.notifyMeModal').data('master-pid') || '';
            let productName = $('.analytics.productListingItem.hidden').data('item_name') || '';
            productName = productName.replace(/\s\s+/g, ' ').split(' ').join('_');
            $('body').trigger('soldout:popupActions', {
                cta: $(e.currentTarget).data('analytics-action'),
                productName: productName,
                size: $('.sizeNotify').text().trim(),
                sku,
            });
            modal.close();
            modal.destroy();
        });

        $(modal.modalBox).on('click', '.analytics-notify-popup-actions', (e) => {
            e.preventDefault();
            let sku = $('div.notifyMeModal').data('master-pid') || '';
            let productName = $('.analytics.productListingItem.hidden').data('item_name') || '';
            productName = productName.replace(/\s\s+/g, ' ').split(' ').join('_');
            $('body').trigger('soldout:popupActions', {
                cta: $(e.currentTarget).data('analytics-action'),
                productName: productName,
                size: $('.sizeNotify').text().trim(),
                sku,
            });
        });

        $(modal.modalBox).on('click', '.js-notifyMeModal-notifyBtn', (e) => {
            let email = $('#emailNotify').val();
            let isValid = validateEmail(email);
            let type = !isComingSoon ? 'back-in-stock' : 'coming-soon';
            let queryString = paramUrl.split('Product-Variation')[1];
            let productName = $('.analytics.productListingItem.hidden').attr('data-item_name') || '';
            let analyticsSku = $('div.notifyMeModal').data('master-pid') || '';
            productName = productName.replace(/\s\s+/g, ' ').split(' ').join('_');

            if (isValid) {
                let dataForm = {
                    sku: $('#skuNotify').val(),
                    owner: email,
                    type: type,
                };
                let url = $('.notify-url').val();
                $.spinner().start();
                $.ajax({
                    url: url + queryString,
                    method: 'POST',
                    dataType: 'json',
                    data: dataForm,
                    success: (data) => {
                        $.spinner().stop();
                        if (data.success) {
                            $('.js-notifyMeModal-toHide').addClass('hidden');
                            if (isComingSoon) {
                                $('#messageGreen').addClass('hidden');
                                $('#comingSoonGreen').removeClass('hidden');
                            }
                            $('#comingSoonGreen').text(data.messageComingSoon);
                            $('#messageGreen').text(data.message);
                            $('.js-notifyMeModal-toShow').removeClass('hidden');
                            $('.js-notifyMeModal-notifyBtn').addClass('hidden');
                            $(
                                '.js-notifyMeModal-titleNotComingSoon,.js-notifyMeModal-titleComingSoon'
                            ).addClass('hidden');
                            $(
                                '.js-notifyMeModal-subTitleNotComingSoon, .js-notifyMeModal-subTitleComingSoon'
                            ).addClass('hidden');
                            $('.continueShopping').removeClass('hidden');
                            $('.js-notifyMeModal-emailError').addClass('hidden');
                            $('.js-notifyMeModal-duplicateError').addClass('hidden');
                            if (!Foundation.MediaQuery.atLeast('medium')) {
                                $('.subtitleHide').addClass('hidden');
                            }
                            $('body').trigger('soldout:notify', {
                                size: $('.sizeNotify').text().trim(),
                                productName: productName,
                                sku: analyticsSku,
                                availability: 'product_notify_me',
                            });
                        } else {
                            if (data.duplicate) {
                                $('.js-notifyMeModal-duplicateError').removeClass('hidden');
                            }
                        }
                    },
                    error: () => {
                        $.spinner().stop();
                    },
                });
            } else {
                $('.js-notifyMeModal-emailError').removeClass('hidden');
            }
        });
    }
}

const notifyHelper = new NotifyHelper();
export default notifyHelper;
